/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Automation_Scale_Title5Inputs */

const en_svc_automation_scale_title5 = /** @type {(inputs: Svc_Automation_Scale_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`High-volume throughput`)
};

const ar_svc_automation_scale_title5 = /** @type {(inputs: Svc_Automation_Scale_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إنتاجية عالية الحجم`)
};

const bn_svc_automation_scale_title5 = /** @type {(inputs: Svc_Automation_Scale_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`হাই-ভলিউম থ্রুপুট`)
};

const de_svc_automation_scale_title5 = /** @type {(inputs: Svc_Automation_Scale_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoher Volumendurchsatz`)
};

const es_svc_automation_scale_title5 = /** @type {(inputs: Svc_Automation_Scale_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rendimiento de alto volumen`)
};

const fr_svc_automation_scale_title5 = /** @type {(inputs: Svc_Automation_Scale_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Débit élevé`)
};

const pt_svc_automation_scale_title5 = /** @type {(inputs: Svc_Automation_Scale_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taxa de transferência de alto volume`)
};

const zh_svc_automation_scale_title5 = /** @type {(inputs: Svc_Automation_Scale_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`大容量吞吐量`)
};

const tr_svc_automation_scale_title5 = /** @type {(inputs: Svc_Automation_Scale_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yüksek hacimli üretim`)
};

const ru_svc_automation_scale_title5 = /** @type {(inputs: Svc_Automation_Scale_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Высокая пропускная способность`)
};

const pl_svc_automation_scale_title5 = /** @type {(inputs: Svc_Automation_Scale_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duża przepustowość`)
};

/**
* | output |
* | --- |
* | "High-volume throughput" |
*
* @param {Svc_Automation_Scale_Title5Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_automation_scale_title5 = /** @type {((inputs?: Svc_Automation_Scale_Title5Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Automation_Scale_Title5Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_automation_scale_title5(inputs)
	if (locale === "bn") return bn_svc_automation_scale_title5(inputs)
	if (locale === "de") return de_svc_automation_scale_title5(inputs)
	if (locale === "es") return es_svc_automation_scale_title5(inputs)
	if (locale === "fr") return fr_svc_automation_scale_title5(inputs)
	if (locale === "pt") return pt_svc_automation_scale_title5(inputs)
	if (locale === "zh") return zh_svc_automation_scale_title5(inputs)
	if (locale === "tr") return tr_svc_automation_scale_title5(inputs)
	if (locale === "ru") return ru_svc_automation_scale_title5(inputs)
	if (locale === "pl") return pl_svc_automation_scale_title5(inputs)
	return en_svc_automation_scale_title5(inputs)
});
export { svc_automation_scale_title5 as "svc_automation_SCALE_title" }